export enum SearchPathsEnum {
  SEARCH = "/search",
  MY_BOOKINGS = "/my-bookings",
}
